import { ArrowUp, CloudArrowUp } from "@phosphor-icons/react";
import {
  Box,
  Button,
  Flex,
  Grid,
  IconButton,
  ScrollArea,
  Text,
  TextField,
} from "@radix-ui/themes";
import { useEffect, useRef } from "react";

import { ChatMessage } from "./ChatMessage";
import { useWorkflow } from "./context";

const panelClasses =
  "rounded-lg bg-base-white p-4 sm:p-6 max-h-[calc(100vh_-_90px)]";

export default function ChatPane() {
  const { assetsCount, messages, uploadFiles } = useWorkflow();

  const threadEndRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (threadEndRef.current) {
      threadEndRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
    }
  }, [messages]);

  return (
    <Box data-testid="chat-panel" className={panelClasses}>
      <Grid gap="5" height="100%" className="grid-rows-[1fr_auto]">
        <ScrollArea
          scrollbars="vertical"
          type="always"
          className="[&>[data-radix-scroll-area-viewport]>div]:w-full"
        >
          <Flex direction="column" justify="end" gap="4" height="100%" pr="3">
            {messages.map((message) => (
              <ChatMessage key={message.id} {...message} />
            ))}

            <div ref={threadEndRef} />
          </Flex>
        </ScrollArea>

        <Box
          position="relative"
          p="5"
          data-files-uploaded={assetsCount > 0}
          className="rounded-2xl border border-dashed border-puntt-accent-9 transition-colors hover:bg-puntt-accent-2 data-[files-uploaded=true]:hidden"
        >
          <Grid gap="4" className="justify-items-center">
            <CloudArrowUp size={36} color="rgb(var(--puntt-blue-9))" />
            <Text size="5" weight="medium" className="text-center" color="blue">
              Drop Files or Folders to Upload
            </Text>
            <Button color="blue" variant="outline" size="2">
              Select Files
            </Button>
          </Grid>
          <input
            type="file"
            multiple
            className="absolute inset-0 cursor-pointer appearance-none opacity-0"
            onChange={async ({ target }) => {
              const files = target.files;

              return uploadFiles(files);
            }}
          />
        </Box>

        <TextField.Root size="3" disabled>
          <TextField.Slot side="right">
            <IconButton size="2" disabled>
              <ArrowUp />
            </IconButton>
          </TextField.Slot>
        </TextField.Root>
      </Grid>
    </Box>
  );
}
